import { SEARCHER_TYPE_TO_MATCH_FOR } from './constants'
import { INTERNATIONAL_CONSENT_STATUS } from '../../models/user/User'

export enum OUS_TEEN_SELF_SEARCH_DESTINATION {
  CONSENT = 'consent',
  TREATMENT_RECOMMENDATIONS = 'treatmentRecommendations',
  FALLBACK_TREATMENT_RECOMMENDATIONS = 'fallbackTreatmentRecommendations',
}

type OUSTeenSelfSearchDestinationArgs = {
  isOUSNeuroEnabled: boolean
  isUserInternational: boolean
  isUserTeen: boolean
  hasAccessToInternationallySupportedTreatmentOptions: boolean
  matchFor: SEARCHER_TYPE_TO_MATCH_FOR
  internationalConsent: INTERNATIONAL_CONSENT_STATUS
}

export const getOUSTeenSelfSearchDestination = ({
  isOUSNeuroEnabled,
  isUserInternational,
  isUserTeen,
  hasAccessToInternationallySupportedTreatmentOptions,
  matchFor,
  internationalConsent,
}: OUSTeenSelfSearchDestinationArgs): OUS_TEEN_SELF_SEARCH_DESTINATION | undefined => {
  if (!isOUSNeuroEnabled || !isUserInternational || !isUserTeen || matchFor !== SEARCHER_TYPE_TO_MATCH_FOR.SELF) {
    return undefined
  }

  // Only ask for international data consent if the customer offers international care
  if (!hasAccessToInternationallySupportedTreatmentOptions) {
    return OUS_TEEN_SELF_SEARCH_DESTINATION.FALLBACK_TREATMENT_RECOMMENDATIONS
  }

  switch (internationalConsent) {
    case INTERNATIONAL_CONSENT_STATUS.NONE:
      return OUS_TEEN_SELF_SEARCH_DESTINATION.CONSENT
    case INTERNATIONAL_CONSENT_STATUS.ACCEPTED:
      return OUS_TEEN_SELF_SEARCH_DESTINATION.TREATMENT_RECOMMENDATIONS
    case INTERNATIONAL_CONSENT_STATUS.DECLINED:
      return OUS_TEEN_SELF_SEARCH_DESTINATION.FALLBACK_TREATMENT_RECOMMENDATIONS
    default:
      return undefined
  }
}
